/* eslint-disable no-restricted-syntax */
/* eslint-disable */
import {
  TCoefficientReport,
  TConvertedCoefficientsReport,
} from '@/pages/supplies-management/children/warehouses-limits/redux/warehouses-limits-module/types';
import { DELIVERY_TYPES } from '@/pages/supplies-management/children/warehouses-limits/redux/warehouses-limits-module/reducer';
import { WAREHOUSE_FILTER_ALL } from '@/pages/supplies-management/children/warehouses-limits/page/_components/connected-warehouses-limits/_constants';

type TParams = {
  report: Array<TCoefficientReport>;
};

export const getFormatterCoefficient = ({
  report,
}: TParams): TConvertedCoefficientsReport => {
  const MAX_DISPLAY = 8;

  const coefficientsReport = report.reduce((acc, el) => {
    let deliveryType: string | null = null;
    if (el.acceptanceType === 6) {
      deliveryType = DELIVERY_TYPES.boxes;
    }
    if (el.acceptanceType === 4) {
      deliveryType = DELIVERY_TYPES.palette;
    }
    if (el.acceptanceType === 5) {
      deliveryType = DELIVERY_TYPES.superSafe;
    }
    if (!deliveryType || !el.warehouseName.length) return acc;

    if (!acc[el.warehouseName]) {
      acc[el.warehouseName] = { [deliveryType]: [el] };
    } else if (acc[el.warehouseName][deliveryType]) {
      acc[el.warehouseName][deliveryType].push(el);
    } else {
      acc[el.warehouseName][deliveryType] = [el];
    }

    return acc;
  }, {});

  const warehousesFilters = Object.entries(coefficientsReport)
    .reduce((acc, [, value]) => {
      const firstItem = value[Object.keys(value)[0]][0];
      acc.push({
        label: firstItem.warehouseName,
        id: firstItem.warehouseName,
        value: firstItem.warehouseID,
      });

      return acc;
    }, [])
    .sort((nameA, nameB) => nameA.label.localeCompare(nameB.label));
  warehousesFilters.unshift(WAREHOUSE_FILTER_ALL);

  const today = new Date();
  const allowedDates = Array(MAX_DISPLAY)
    .fill(null)
    .map(
      (el, index) =>
        new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() + index,
        ),
    );

  return { coefficientsReport, warehousesFilters, allowedDates };
};
